import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_lime-booking-hub/artifacts/7qzkvjwv_lime%20header%20image.jpg";

export default function PageHero({ eyebrow, title, subtitle, ctaLabel = "Book your lessons", ctaTo = "/packages", showCta = true }) {
  return (
    <section className="relative overflow-hidden bg-[#111827]" data-testid="page-hero">
      {/* Image — full width on mobile, right half on desktop */}
      <div className="absolute inset-0 md:inset-y-0 md:left-1/2 md:right-0 md:w-1/2">
        <img src={HERO_IMG} alt="" className="w-full h-full object-cover" />
        {/* Mobile: darker overlay so left-aligned text stays readable */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#111827] via-[#111827]/70 to-[#111827]/10 md:hidden" />
        {/* Desktop: curved cut on the image's left edge that blends into the dark left half */}
        <svg className="hidden md:block absolute inset-y-0 -left-1 h-full w-24"
             viewBox="0 0 100 400" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,0 L100,0 C20,120 20,280 100,400 L0,400 Z" fill="#111827" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 lg:py-32">
        <div className="md:max-w-lg">
          {eyebrow && (
            <span className="inline-block text-xs uppercase tracking-[0.2em] font-semibold text-[#37B160] mb-4">
              {eyebrow}
            </span>
          )}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none font-medium text-white"
              style={{fontFamily: "Outfit, sans-serif"}}>
            {title}
          </h1>
          {subtitle && (
            <p className="mt-5 text-base sm:text-lg text-white/85 leading-relaxed max-w-xl">
              {subtitle}
            </p>
          )}
          {showCta && (
            <div className="mt-8">
              <Link to={ctaTo} data-testid="page-hero-cta">
                <Button className="bg-[#37B160] hover:bg-[#2D9450] text-white h-12 px-7 text-base active:scale-95 transition-transform">
                  {ctaLabel} <ArrowRight className="h-4 w-4 ml-1" />
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* BSM-style curved transition into next section */}
      <svg className="absolute bottom-[-1px] left-0 w-full h-[60px] md:h-[90px]"
           viewBox="0 0 1440 90" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,90 L0,50 C360,-15 1080,-15 1440,50 L1440,90 Z" fill="#FDFCFB" />
      </svg>
    </section>
  );
}
